// extracted by mini-css-extract-plugin
module.exports = {"title":"JvHnS","control":"_7IPg8","mainTitle":"vhDZ2"};